import Panelcommission from '../panelcommission/panelcommission.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import Salesinformation from '../salesinformation/salesinformation.vue'
import Commissionform from '../commissionform/commissionform.vue'

const Tabs = {
  Detalhes: 0,
  valor: 1,
  comissao: 2
}

export default {
  components: {Salesinformation, Commissionform, Panelcommission},
  name: 'Commissiondetails',
  mixins: [ActionsForm],
  props: ['dataDetails'],
  data () {
    return {
      headTable: ['Valor de parcela', 'Vencimento', 'status'],
      tabIndex: Tabs.Detalhes
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/commissioncheck/components/commissiondetails/commissiondetails.js